import {ReverseGeocodingData} from "@containers/reverseGeocoding/types";

export const buildNameReverseGeocoding = (res: ReverseGeocodingData) => {
    if (res?.address?.city && res?.address?.road && res?.address?.house_number) {
        return `${res?.address?.city}, ${res?.address.road}, ${res.address.house_number}`
    }
    if (res?.address?.road && res?.address?.house_number) {
        return `${res?.address.road}, ${res.address.house_number}`
    }

    if (res?.name?.length >= 1 && res?.address?.city) {
        return `${res.address.city}, ${res.name}`
    }

    if (res?.name?.length >= 1) {
        return res.name
    }

    if (res?.address?.road) {
        return res.address.road

    }
    return res?.display_name;

}